import { render, staticRenderFns } from "./redPropagandaAdd.vue?vue&type=template&id=e6f55126&scoped=true&"
import script from "./redPropagandaAdd.vue?vue&type=script&lang=js&"
export * from "./redPropagandaAdd.vue?vue&type=script&lang=js&"
import style0 from "./redPropagandaAdd.vue?vue&type=style&index=0&id=e6f55126&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f55126",
  null
  
)

export default component.exports